import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-tethered-input',
  templateUrl: './tethered-input.component.html',
  styleUrls: ['./tethered-input.component.css']
})
export class TetheredInputComponent{
  //figure out how to make these inputs
  minValue: number = 0;
  maxValue: number = 100;
  @Input() labelOne;
  @Input() labelTwo;
  @Input() valueOne: number = 0;
  @Input() valueTwo: number = 0;
  @Output() valueOneChange = new EventEmitter<number>();
  @Output() valueTwoChange = new EventEmitter<number>();

  constructor() { }

  //valueTwo must aways be >= valueOne
  updateValueOne(){
    if(this.valueOne < this.minValue || this.valueOne == null){
      this.valueOne = this.minValue;
    }
    if(this.valueOne > this.valueTwo){
      this.valueTwo = this.valueOne;
      this.updateValueTwo();
    }
    this.valueOneChange.emit(this.valueOne);
  }

  updateValueTwo(){
    if(this.valueTwo < this.minValue || this.valueTwo == null){
      this.valueTwo = this.minValue;
    } 
    if(this.valueTwo < this.valueOne){
      this.valueOne = this.valueTwo;
      this.updateValueOne();
    }
    this.valueTwoChange.emit(this.valueTwo);
  }
}
